import formComponent from '@/util/proto/formComponent'

export default {
  extends: formComponent ,
  data() {
    return {
      formData: {
        categoryName: {
          rules:[
            { required: true, message: '请输入分类名称', trigger: 'blur,change' },
          ]
        },
        genre: {
          rules:[
            { type: 'number', required: true, message: '请选择类型', trigger: 'blur,change' },
          ]
        },
        imgPath: {
          rules:[
            { required: true, message: '请上传图片', trigger: 'blur,change'},
          ]
        },
        supplyWarranty:{
          rules:[
            { type: 'number', required: true, message: '请选择保修类型', trigger: 'blur,change' },
          ]
        },
        orders: {
          initialValue:999,
          rules:[
            { type: 'number', required: true, message: '请设置配件排序', trigger: 'blur,change' },
          ]
        },
        warrantyTime:{
          rules:[{ type:'number', required: true , message: '请输入保修期限', trigger: 'blur,change' }]
        },
        remark:null
        
      },
      id:null,
      loading:false,
      visible:false,
      raw:{},
      state:{c:0},
      api:['assPartsCateCreate','assPartsCateUpdate'],
    }
  },

  computed:{
    title(){
      return this.id ? '修改配件分类' : '新增配件分类'
    },
    warrantyTimeDecorator(){
       
      let supplyWarranty = this.form ? this.form.getFieldValue('supplyWarranty') : null
      return [
        'warrantyTime',
        {
          initialValue:this.raw.warrantyTime || null,
          rules:[
            { type:'number', required: !!supplyWarranty , message: '请输入保修期限', trigger: 'blur,change' },
            // { message: '请输入保修期限', trigger: 'blur,change' },
          ]
        }
      ]
    }
  },

  methods: {
    init(id) {
      this.id = id
      this.visible = true
      this.$resetFormData()
      if (this.id) {
        this.query()
      }
    },

    query(){
      this.loading = true
      console.log(this.$request.assPartscate)
      this.$request.assPartsCate(this.id).then(resp => {
        this.$setFormData(resp.data)
        this.raw = resp.data
        this.loading = false
      })
    },
    beforeSave(d){
      let params = { ...d }
      if(this.id){
        params.id = this.id
      }
      return params
    }
  },

  render(){
    let supplyWarranty = this.form ? this.form.getFieldValue('supplyWarranty') : null
    return (
      <sl-side-panel v-model={this.visible} loading={this.loading} title={this.title}>
        <sl-form label-width={100}>
          <sl-form-item label="配件名称">
            <Input v-decorator={this.formData.categoryName}></Input>
          </sl-form-item>
          <sl-form-item label="配件类型">
            <sl-select v-decorator={this.formData.genre} dict="genre" />
          </sl-form-item>
          <sl-form-item label="配件图片">
            <sl-upload public={true} style="margin-top:8px;" v-decorator={this.formData.imgPath} type="18" limit={1}></sl-upload>
          </sl-form-item>
          <sl-form-item label="保修政策">
            <RadioGroup v-decorator={this.formData.supplyWarranty}>
              <Radio label={1}>
                <span>保修</span>
              </Radio>
              <Radio label={0}>
                <span>无保修</span>
              </Radio>
            </RadioGroup>
          </sl-form-item>
          <sl-form-item label="保修期" v-show={supplyWarranty}>
            <InputNumber min={1} active-change={false} v-decorator={this.warrantyTimeDecorator} /><span style="margin-left:5px;">月</span>
          </sl-form-item>
          <sl-form-item label="配件排序">
            <InputNumber v-decorator={this.formData.orders} min={1} step={1} parser={ v => v.replace(/[^\d]/g, '')} active-change={false} />
          </sl-form-item>
          <sl-form-item label="备注">
            <Input type="textarea" autosize={{minRows: 5,maxRows: 8}} v-decorator={this.formData.remark}></Input>
          </sl-form-item>
        </sl-form>
        <template slot="footer">
          <Button loading={this.loading} on-click={this.$handleSubmit} type="primary">确定</Button>
        </template>
      </sl-side-panel>
    )
  }
}

export const View = {
  data() {
    return {
      id: null,
      loading: false,
      data: {},
      visible: false,
    }
  },
  methods: {

    init(id) {
      this.id = id
      this.visible = true
      if (this.id) {
        this.query()
      }
    },

    query() {
      this.loading = true
      this.$request.assPartsCate(this.id).then( resp => {
        this.loading = false
        if(resp.code == 0){
           this.data = this.$utils.conv(resp.data,{'genre':'genre'})
        }else{
          this.visible = false
          this.$Message.error({ content: resp.msg })
        }
      })
    },
  },
  render(){
    const { loading , data } = this
    return (
      <sl-side-panel destroyOnClose={true} v-model={this.visible} mask-closable={false} title="查看配件分类" loading={loading}>
        <sl-detail-list col={1} label-width="100px" label-align="right" style="padding:12px;">
          <sl-detail-list-item title="配件名称">{data.categoryName}</sl-detail-list-item>
          <sl-detail-list-item title="配件类型">{data.genreText}</sl-detail-list-item>
          <sl-detail-list-item title="配件图片">
            <sl-img width="90px" height="90px" public={true} src={data.imgPath} />
          </sl-detail-list-item>
          <sl-detail-list-item title="保修政策">
            <span style="color:rgba(0, 0, 0, 0.45);font-size:12px;display:flex;align-items:center;">
              <Icon custom="i-icon icon-insurance" style={{'marginRight':'6px',color:data.supplyWarranty ? '#52c41a' : 'currentColor'}} />
              <span>{data.supplyWarranty ? data.warrantyTime+'个月' : '无保修'}</span>
            </span>
          </sl-detail-list-item>
          <sl-detail-list-item title="配件排序">{data.orders}</sl-detail-list-item>
          
          <sl-detail-list-item title="备注">{data.remark}</sl-detail-list-item>
        </sl-detail-list>
      </sl-side-panel>
    )
  }
}